/**
 * Bus de step-up (LOT 5.5.1) — découple les aides d'appel API du dialogue.
 *
 * `adminMutate` (primitives) détecte STEPUP_REQUIRED et demande ici une
 * ré-authentification forte ; le PROVIDER du shell enregistre le vrai
 * dialogue (TOTP ou clé d'accès). Une même promesse est partagée si deux
 * mutations tombent sur le mur en même temps — un seul dialogue s'ouvre.
 */

let requester: (() => Promise<boolean>) | null = null
let pending: Promise<boolean> | null = null

export function setStepUpRequester(fn: (() => Promise<boolean>) | null): void {
  requester = fn
}

export function requestStepUp(): Promise<boolean> {
  if (!requester) return Promise.resolve(false)
  if (!pending) {
    pending = requester().finally(() => { pending = null })
  }
  return pending
}
